@use "../../../sass/variables/colors";

.ux-sidebar-content {
  flex: 1 1 auto;
  overflow: auto;
  width: 100%;

  p {
    color: colors.$color-gray-text;
  }
}
